export default "__VITE_ASSET__BJnSanbS__"